import { render, staticRenderFns } from "./special-request.vue?vue&type=template&id=a534276e&"
import script from "./special-request.vue?vue&type=script&lang=js&"
export * from "./special-request.vue?vue&type=script&lang=js&"
import style0 from "./special-request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports